import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';

interface OrderValidationErrorsTooltipContentProps {
  errors: string[];
  title?: LangEnum;
}

const OrderValidationErrorsTooltipContent = ({
  errors,
  title = LangEnum.ORDER_VALIDATION_REGISTRATION_PENDING,
}: OrderValidationErrorsTooltipContentProps) => {
  const { translate } = useTranslation();

  return (
    <Stack sx={{ gap: 1 }}>
      <Typography variant="subtitle2" color="inherit">
        {translate(title)}
      </Typography>

      <Stack sx={{ gap: 0.5 }}>
        {errors.map((error, index) => (
          <Typography key={error} variant="body2" color="inherit">
            {index + 1}. {error}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};

export default OrderValidationErrorsTooltipContent;
